import { setDomainAuthErrorHandler, setDomainDobConfirmationHandler } from '@shared/api/api-factory'
import { FINGERPRINTING_ROUTES } from './constants/routes'

export function initFingerprintingDomain() {
  setDomainAuthErrorHandler('fingerprinting', () => {
    if (typeof window !== 'undefined') {
      const currentPath = window.location.pathname
      if (!currentPath.startsWith(FINGERPRINTING_ROUTES.LOGIN)) {
        window.location.href = `${FINGERPRINTING_ROUTES.LOGIN}?requireAuth=true`
      }
    }
  })

  setDomainDobConfirmationHandler('fingerprinting', () => {
    if (typeof window !== 'undefined') {
      window.location.href = FINGERPRINTING_ROUTES.CONFIRM_DOB
    }
  })
}
